var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclecomment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_961_36928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 40.5,
    r: 22.5,
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 38.2667C40 35.3731 40 33.9263 40.5631 32.8211C41.0585 31.8489 41.8489 31.0585 42.8211 30.5631C43.9263 30 45.3731 30 48.2667 30H54.9833C57.8769 30 59.3237 30 60.429 30.5631C61.4011 31.0585 62.1915 31.8489 62.6868 32.8211C63.25 33.9263 63.25 35.3731 63.25 38.2667V39.8167C63.25 42.7103 63.25 44.1571 62.6868 45.2623C62.1915 46.2344 61.4011 47.0248 60.429 47.5202C59.3237 48.0833 57.8769 48.0833 54.9833 48.0833H45.7017C45.3591 48.0833 45.0306 48.2195 44.7884 48.4617L42.205 51.045C41.3913 51.8587 40 51.2824 40 50.1317V48.0833V41.625V38.2667ZM47.75 35.1667C47.0366 35.1667 46.4583 35.745 46.4583 36.4583C46.4583 37.1717 47.0366 37.75 47.75 37.75H55.5C56.2134 37.75 56.7917 37.1717 56.7917 36.4583C56.7917 35.745 56.2134 35.1667 55.5 35.1667H47.75ZM47.75 40.3333C47.0366 40.3333 46.4583 40.9116 46.4583 41.625C46.4583 42.3384 47.0366 42.9167 47.75 42.9167H51.625C52.3384 42.9167 52.9167 42.3384 52.9167 41.625C52.9167 40.9116 52.3384 40.3333 51.625 40.3333H47.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_961_36928",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.647059 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_961_36928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_961_36928",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclecomment);
export default __webpack_public_path__ + "static/media/circlecomment.03cbc12f2f802a50f85128877a2d1f1a.svg";
export { ForwardRef as ReactComponent };